export default __webpack_public_path__ + "static/media/code.b68e6c1d.svg";